import React from 'react';
import { Grid, ListGroup, Table } from 'react-bootstrap';
import PowerplantRowMini from '../Powerplant/PowerplantRowMini';
import PowerplantRow from './../Powerplant/PowerplantRow';
import Overview from './../Map/Overview';
import './Body.css';
import SortingBarTableHeader from './SortingBarTableHeader';
import SortingBarMobile from './SortingBarMobile';
import { Scrollbar } from "react-scrollbars-custom";
import Sort from './Service/Sort';
import Filter from './Service/Filter';
import Header from './Header';
import services from './../../lib/Services';

const HIGH_PERCENT_AUTO = 97;

class Body extends React.Component
{	
	constructor(props)
	{
		super(props);
        this.sort = new Sort();
        // Default : sort by name
        this.sort.setKey('name');
        this.filter = new Filter();
        // Default : filter only "in operation" powerplant
        this.filter.setKey('step', 0);
		this.state = {
			// Locate powerplant on map
			selectedPowerplantOnMap: null,
			// Height of scrollbar
			height: null,
			// Width of scrollbar
			width: null
		}
        this.setSorting = this.setSorting.bind(this);
        this.setFiltering = this.setFiltering.bind(this);
        this.setSelectedPowerplantOnMap = this.setSelectedPowerplantOnMap.bind(this);
        this.refreshOnLoad = this.refreshOnLoad.bind(this);
	}

	componentWillMount()
    {
		this.setState({height: (window.innerHeight - (window.innerHeight/9)) + 'px'});
		this.setState({width: window.innerWidth});
	}
    
	setSelectedPowerplantOnMap(app_id)
    {
		this.setState({selectedPowerplantOnMap: app_id});
	}

	setSorting(data)
    {
        this.sort.setKey(data);
        this.forceUpdate();
	}

	setFiltering(column, value)
    {
        this.filter.setKey(column, value);
        this.setState({selectedPowerplantOnMap: null});
        this.forceUpdate();
	}
    
    refreshOnLoad()
    {
        this.forceUpdate();
    }

	render()
	{
        if(services.getUser().isDemo()) {
            this.filter.setKey("percent_auto", HIGH_PERCENT_AUTO)
        }
        
        this.filter.apply(this.props.powerplants);
		this.sort.apply(this.props.powerplants);

		// To change the component to display relative to the screen's size
		const ToDisplay = (this.state.width <= 991) ? PowerplantRowMini : PowerplantRow;

		return (
			<div className="main-body">
                <Header total={this.props.total} />
				<SortingBarMobile className="sorting-dropdown" setSorting={this.setSorting} />
				<Grid fluid className="body" style={{paddingLeft:'50px',marginBottom:'0'}}>
					<ListGroup className="col-md-8">
						<Scrollbar style={{ width: '100%', height: this.state.height, color:'#FFFFFF', backgroundColor:'#0E202D' }}>
							<Table>
								<SortingBarTableHeader setSorting={this.setSorting} setFiltering={this.setFiltering} />
								<tbody>
									{ this.props.powerplants.map(pp => <ToDisplay
                                                                app_id={pp.getAppId()}
                                                                powerplant={pp} 
                                                                key={pp.getAppId()}
                                                                setSelectedPowerplantOnMap={this.setSelectedPowerplantOnMap}
                                                                refreshOnLoad={this.refreshOnLoad} />)}
								</tbody>
							</Table>
						</Scrollbar>
					</ListGroup>
					<div className="col-md-4 map-style">
						<div>
							<Overview powerplants={this.props.powerplants} selectedPowerplantOnMap={this.state.selectedPowerplantOnMap} />
						</div>
					</div>
				</Grid>
			</div>
		);
	}
}

Body.defaultProps = {
    total: 0,
	powerplants: []
};

export default Body